import React from "react";
import { Redirect } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import HelenAPI from "@helen/sdk";
import CircularProgress from "@material-ui/core/CircularProgress";
import AppDialog from "./AppDialog";

const styles = theme => ({
  settingFormControl: {
    marginTop: "10%",
    width: "100%",
    maxWidth: 360,
    marginLeft: "auto",
    marginRight: "auto"
  },
  margin: {
    marginTop: theme.spacing.unit,
    width: "100%"
  },
  button: {
    marginTop: 15,
    color: "#009688",
    float: "right"
  },
  linkStyle: {
    textDecoration: "none"
  },
  cssLabel: {
    "&$cssFocused": {
      color: "#009688"
    }
  },
  cssFocused: {},
  cssUnderline: {
    "&:after": {
      borderBottomColor: "#009688"
    }
  }
});

class ApiSelector extends React.Component {
  state = {
    baseUrl: "",
    succeeded: false,
    hasError: false,
    showErrorModal: false,
    loading: false
  };

  validateUrlFormat = str => {
    const regex = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}[.]{0,1}/;
    if (!regex.test(str)) {
      return false;
    }
    return true;
  };

  // To validate the base URL entered by the user, by triggering a dummy call to get languages
  validateBaseUrl = async () => {
    this.setState({ loading: true });
    let { baseUrl } = this.state;
    if (!baseUrl) {
      this.setState({ hasError: true, loading: false });
      return;
    }
    if (baseUrl.endsWith("/")) {
      baseUrl = baseUrl.slice(0, -1);
    }
    HelenAPI.setBaseUrl(baseUrl);
    if (!this.validateUrlFormat(baseUrl)) {
      this.setState({ hasError: true, showErrorModal: true, loading: false });
      return;
    }
    try {
      await HelenAPI.getLanguages();
    } catch (error) {
      if (error.status && error.status === 401) {
        this.setState({ succeeded: true });
        return;
      }
      this.setState({ hasError: true, showErrorModal: true, loading: false });
      return;
    }
    this.setState({ succeeded: true });
  };

  // Rendering elements in API selector screen
  render = () => {
    const { classes } = this.props;
    if (this.state.succeeded) {
      return <Redirect to="/signin" />;
    }
    return (
      <div className={classes.settingFormControl}>
        <Typography variant="title" gutterBottom>
          Connect to Helen API
        </Typography>
        <Typography variant="body2" gutterBottom>
          Please enter the Helen API Address that corresponds to your instance
          of Helen
        </Typography>
        <FormControl className={classes.margin} error={this.state.hasError}>
          <InputLabel
            FormLabelClasses={{
              root: classes.cssLabel,
              focused: classes.cssFocused
            }}
            htmlFor="api-input"
          >
            Helen API Address
          </InputLabel>
          <Input
            error={this.state.hasError}
            classes={{
              underline: classes.cssUnderline
            }}
            id="api-input"
            value={this.state.baseUrl}
            required
            onChange={({ target: { value } }) => {
              this.setState({ baseUrl: value, hasError: false });
            }}
          />
        </FormControl>
        <br />
        <Button
          variant="raised"
          className={classes.button}
          onClick={this.validateBaseUrl}
          disabled={this.state.loading}
        >
          NEXT
        </Button>
        {this.state.loading && (
          <CircularProgress
            className={classes.progress}
            style={{ color: "#004D40", marginLeft: "65%", marginTop: "6%" }}
            size={24}
          />
        )}
        <AppDialog
          open={this.state.showErrorModal}
          text="The URL you provided seems to be invalid. Please check!"
          title="Inavlid Helen API endpoint"
          onClose={() => this.setState({ showErrorModal: false })}
        />
      </div>
    );
  };
}

ApiSelector.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ApiSelector);



// WEBPACK FOOTER //
// ./src/components/ApiSelector.jsx